// useDashboard.js
import { useQuery } from '@tanstack/react-query';
import dashboardService from '../services/dashboard.js/dashboard-service';

export const useAvailableDates = (network) => {
  return useQuery({
    queryKey: ['dashboard', 'dates', network],
    queryFn: () => dashboardService.getAvailableDates(network),
    enabled: !!network,
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

export const useDashboardData = (reportParameters, operations) => {
  return useQuery({
    queryKey: ['dashboard', 'data', reportParameters, operations],
    queryFn: () => dashboardService.getDashboardData(reportParameters, operations),
    enabled: !!(
      reportParameters?.network &&
      reportParameters?.dataset &&
      reportParameters?.year &&
      reportParameters?.timePeriod
    ),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 30,
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};
